module.exports = __webpack_public_path__ + "static/media/login-background-desktop.d72c9518.svg";